module.exports = __webpack_public_path__ + "static/media/work (11).fe45cdaf.jpg";